/* eslint-disable prefer-destructuring,func-names,react/prop-types,prefer-arrow-callback */

import { Spin, Upload, Input, Icon } from 'antd';
import _ from 'lodash';
import React from 'react';

import Button from '../../views/StyledButton';
import StyledTable from '../../views/StyledTable';
import ContentWidthClamper from '../../views/ContentWidthClamper';
import ButtonList from '../../views/ButtonList';
import { FormRow } from '../../views/Form';
import PageFrame from '../../views/PageFrame';
import HeadlineBreadcrumbList from '../../views/HeadlineBreadcrumbList';
import SelectableHeader from '../../views/SelectableHeader';
import SearchFrame from '../../views/SearchFrame';
import WeightWidget from '../../views/WeightWidget';
import NameSearchFrame from '../../views/NameSearchFrame';
import DeleteCheckedButton from '../../views/DeleteCheckedButton';

export default (bottle) => {
  // eslint-disable-next-line prefer-arrow-callback
  bottle.factory(
    'TerminusDrilldownView',
    function () {
      return ({
        termsCheckList, columns, uploadProps, data, canDelete,
        editingVocabularyWeight, setEditingVocabularyWeight, setSearchTerm,
        rowSelection, vocabularyName, deleteChecked, searchTerm,
        scrollY, save, currentTermEditedName, setEditingTermName, revert,
        deleteVocabulary, goBack, goHome, isLoading, tableProps, headline,
        canSave, isNew,
      }) => (
        <div>
          <PageFrame noBottom>
            <ContentWidthClamper>
              <HeadlineBreadcrumbList>
                {[
                  { onClick: goHome, text: 'Home' },
                  { onClick: goBack, text: 'Vocabulary Lists  ' },
                  headline,
                ]}
              </HeadlineBreadcrumbList>
            </ContentWidthClamper>
          </PageFrame>
          <PageFrame noTop noBottom>
            <NameSearchFrame>
              <FormRow label="Name" labelSpan={5} bottomMargin={0} height={35}>
                <Input
                  value={currentTermEditedName}
                  onChange={event => setEditingTermName(event.target.value)}
                />
              </FormRow>
              <SearchFrame value={searchTerm} onChange={setSearchTerm} />
            </NameSearchFrame>

            <SelectableHeader dataHidden={!termsCheckList.length}>
              <DeleteCheckedButton
                style={(
                  {
                    width: _.get(columns, '0.width', 350) + 48,
                  }
                )}
                onClick={deleteChecked}
              >Delete Checked
              </DeleteCheckedButton>
              <div style={({
                width: _.get(columns, '1.width', 150),
              })}
              ><WeightWidget
                weight={editingVocabularyWeight}
                onChange={setEditingVocabularyWeight}
              />
              </div>
            </SelectableHeader>
            <StyledTable
              columns={columns}
              hightlightSelectable={termsCheckList.length}
              rowSelection={rowSelection}
              pagination={false}
              dataSource={data}
              loading={isLoading}
              rowKey="id"
              scroll={({ y: scrollY })}
              {...tableProps}
              footer={() => (
                <div id="spotting-group-terms-footer">
                  <ButtonList line={false} expandFirst>
                    <Upload {...uploadProps}>
                      <Button>
                        <Icon type="upload" /> Import CSV
                      </Button>
                    </Upload>
                    {!isNew && <Button onClick={revert}>Revert</Button>}
                    {!isNew && (
                    <Button
                      type="danger"
                      disabled={!canDelete}
                      onClick={deleteVocabulary}
                    >Delete
                    </Button>
                    )}
                    <Button
                      type="primary"
                      onClick={save}
                      disabled={!canSave}
                    >Save
                    </Button>
                  </ButtonList>
                </div>)}
            />
          </PageFrame>
        </div>
      );
    },
  );
};
